import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { LongContentModal } from "../modals";

type Props = {};

const DBFooter: React.FC<Props> = (props: Props) => {
	const [showTermsOfServiceModal, setShowTermsOfServiceModal] = useState<boolean>(false);
	const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState<boolean>(false);

	return (
		<>
			<footer className="main-footer">
				<div className="copyright-wrap">
					<h5>Copyrights {new Date().getFullYear()}</h5>
				</div>
				<div className="policies-wrap">
					<Button variant="link" onClick={() => setShowPrivacyPolicyModal(true)}>
						Privacy Policy
					</Button>
					<Button variant="link" onClick={() => setShowTermsOfServiceModal(true)}>
						Terms of use
					</Button>
				</div>
			</footer>
			<LongContentModal
				showModal={showTermsOfServiceModal}
				title="Terms of Use"
				onYesBtnText="Close"
				onYesBtnClick={() => {
					setShowTermsOfServiceModal(false);
				}}
				actionKey={"termsOfService"}
			/>

			<LongContentModal
				showModal={showPrivacyPolicyModal}
				title="Privacy Policy"
				onYesBtnText="Close"
				onYesBtnClick={() => {
					setShowPrivacyPolicyModal(false);
				}}
				actionKey={"privacyPolicy"}
			/>
		</>
	);
};

export default DBFooter;
